module.exports = __webpack_public_path__ + "img/sound-submit.f35b48a8.png";